import React from "react";
import { Fade, Flip } from "react-reveal";
import Bounce from "react-reveal/Bounce";
// import img
import Wobble from "react-reveal/Wobble";
import { Link } from "react-scroll";
import ProgressSlide from "./ProgressSlide";

const About = () => {
  return (
    <section className="section bg-secondary" id="about">
      <div className="container mx-auto">
        <div className="flex flex-col w-full mx-auto xl:flex-row items-center gap-3">
          <Wobble>
            <div className="w-4/6 lg:w-2/6 mx-auto">
              <img
                className="object-cover h-full w-full mx-auto md:mx-auto lg:mx-0 rounded-2xl"
                src="https://i.ibb.co/NjBnVrj/resize.png"
                alt=""
              />
            </div>
          </Wobble>
          <div className="flex w-5/6 lg:w-3/6 mx-auto flex-col items-center text-center lg:items-start lg:text-left">
            <div className="flex flex-col">
              <Flip>
                <h2 className="text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3 before:content-about relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block">
                  Ashraful Islam
                </h2>
                <p className="mb-4 text-xl text-accent">
                  Junior Software Developer
                </p>
              </Flip>
              <hr className="mb-8 opacity-5" />
              <p className="mb-8">
                <Bounce left>
                  In the early stage, I started my career as a Marketing Officer
                  and then rapidly moved into Web Design & Development. I Have
                  Completed Web Design Course from Robi 10 Minute School.
                  Currently Completed Web Development Course From Programming
                  Hero as Front-End Web Developer. And winning a reward (SCIC
                  selection) from the Programming Hero for my Better
                  Performance. I enjoy when completed a project and I work hard
                  to reach the destination. I love team leading, project
                  management, problem-solving, and of course strategic decision
                  making!
                </Bounce>
                <br />
                <br />
                <Bounce right>
                  I'm a big fan of taking ownership and exploring technical and
                  business challenges to achieve the best output. I consider
                  myself As a fully dedicated, dynamic, punctual, efficient,
                  quick responder, and also very convivial.
                </Bounce>
              </p>
            </div>
            <Fade bottom>
              <Link
                to="contact"
                activeClass="active"
                spy={true}
                smooth={true}
                duration={500}
                offset={-70}
                className="btn btn-md bg-accent hover:bg-secondary-hover cursor-pointer transition-all duration-300"
              >
                Contact me
              </Link>
            </Fade>
          </div>
        </div>
      </div>
      <div className="">
        <ProgressSlide />
      </div>
    </section>
  );
};

export default About;
